import { TYPO } from "styles/Typo";
import DiagnosisLayout from "./Layout";
import { useParams } from "next/navigation";
import { useFinanceData } from "utils/clientAPIs/detailDiagnosis";
import { IndexBarChart } from "components/pages/detail/Fin";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import SkeletonBlock from "components/skeleton";
import { TrackedLink } from "lib/analytics/react/link";
function DetailDiagnosisFin({
  score,
  base_dt,
  detailData,
}: {
  score?: number;
  base_dt?: string;
  detailData: any;
}) {
  const router = useRouter();
  const { t } = useTranslation("detail");
  const { ticker } = useParams();
  const ITEM_CD = detailData?.ITEM_CD;
  const [finData, isLoading] = useFinanceData(ticker as string, ITEM_CD, true);
  // 지표 정렬
  const so = ["안정성", "수익성", "활동성", "현금흐름"];
  const sortValues = finData?.values?.sort((a: any, b: any) => {
    const indexA = so.indexOf(a.field);
    const indexB = so.indexOf(b.field);
    return (
      (indexA === -1 ? so.length : indexA) -
      (indexB === -1 ? so.length : indexB)
    );
  });
  const WEIGHTED_INDI_PER = sortValues?.map((item: any) => {
    return {
      field: item.field,
      WEIGHTED_INDI_PER: item.WEIGHTED_INDI_PER,
      INDI_STATE: sortValues.find((value: any) => value.field === item.field)
        ?.INDI_STAT,
    };
  });

  const loading = (!score && String(score) !== "0") || isLoading || !detailData;
  const period = String(finData?.REPT_PERIOD || base_dt || "");
  const year = period.slice(0, 4);
  const quarter = Number(period.slice(4, 6) || period.slice(5, 6) || 0);
  const lastUpdateDate =
    year && quarter
      ? router.locale === "ko"
        ? `${year.slice(2)}년 ${quarter}분기`
        : `${year} Q${quarter}`
      : period;

  if (loading) {
    return (
      <div className="px-6 pt-[30px] pb-1 gap-1 flex flex-col">
        <SkeletonBlock width={"100%"} height={289} radius={10} />
      </div>
    );
  }
  return (
    <div className="px-6 pt-[30px] pb-1 gap-1 flex flex-col">
      <DiagnosisLayout>
        <DiagnosisLayout.Header score={score}>
          <DiagnosisLayout.Header.Title>
            {t("financialSoundness")}
          </DiagnosisLayout.Header.Title>
          <DiagnosisLayout.Header.SubTitle>
            {score && score >= 50 ? t("finStableDesc") : t("finUnstableDesc")}
          </DiagnosisLayout.Header.SubTitle>
        </DiagnosisLayout.Header>
        <DiagnosisLayout.ContentWrapper height={300}>
          <div className="w-full p-4 border-t border-gray15 bg-white">
            {WEIGHTED_INDI_PER?.length > 0 && (
              <IndexBarChart
                WEIGHTED_INDI_PER={WEIGHTED_INDI_PER}
                router={router}
              />
            )}
          </div>
        </DiagnosisLayout.ContentWrapper>
        <TrackedLink
          href={`/detail/${ticker}/fin`}
          itemspec={{
            kind: "section_nav",
            section_id: "stock_attractiveness_fin",
            nav_key: "stock_navbtn_fin_detail",
          }}
          asTrace={true}
        >
          <DiagnosisLayout.ViewMore
            onClick={() => {
              router.push(`/detail/${ticker}/fin`);
            }}
            type="fin"
          />
        </TrackedLink>
      </DiagnosisLayout>
      <div className="flex justify-end">
        <p className={`${TYPO.TYPO8_RG} text-gray40`}>
          {t("lastUpdated", { date: lastUpdateDate })}
        </p>
      </div>
    </div>
  );
}

export default DetailDiagnosisFin;
